// extracted by mini-css-extract-plugin
export default {"uniLogo":"_9Cg4nEl1Stai2FNDgsIw"};